<template>
  <span>
    <b v-if="stopped">{{ select }}</b>
    <b v-else>{{ number }}</b>
  </span>
</template>
<script>
export default {
  name: 'SlotNumber',
  props: {
    select: {
      type: [Number, String],
      default: 0
    },
    timeout: {
      type: Number,
      default: 10
    },
    start: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stopped: false,
      Interval: null,
      setTimeout: null,
      number: 0
    }
  },
  computed: {

  },
  methods: {
    spinning() {
      let running = this.start
      clearInterval(this.Interval)
      this.Interval = setInterval(() => {
        running++;
        this.number = running % 10
      }, 100);
    }
  },
  mounted() {
    this.spinning()
    this.setTimeout = setTimeout(()=>{
      this.stopped = true
      clearInterval(this.Interval)
    }, this.timeout)
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}
</script>
